import { Row, Col } from 'react-bootstrap';
import CurrencyField from '../../fields/CurrencyField';
import AdditionalInformationField from '../../fields/AdditionalInformationField';
import { MIN_PLEDGE, MAX_WINTER_HELP_PLEDGE, MAX_NUMBER, STATES, FUND_TYPES } from '../../../../constants/constants';
import PledgeLimitReachedModal from './PledgeLimitReachedModal';
import { useEffect, useState } from 'react';

const WinterHelpSection = ({
  pledgeAmount,
  onPledgeAmountChange,
  additionalInformation,
  onAdditionalInformationChange,
  state,
  setFundType,
  winterHelpPledges,
  isSubmitting,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setFundType('');
    setShowModal(false);
  };

  const isIneligible = winterHelpPledges?.length > 0 || false;


  useEffect(() => {
    if (isIneligible) {
      setShowModal(true);
    }
  }, [isIneligible]);

  return (
    <>
      <hr/>

      <Row>
        <h4>Benefit Amount</h4>
        <Col md={6}>
          <CurrencyField
            value={pledgeAmount}
            min={MIN_PLEDGE}
            max={MAX_WINTER_HELP_PLEDGE}
            fieldName="Pledge Amount"
            onChange={onPledgeAmountChange}
            isSubmitting={isSubmitting}
            required
          />
        </Col>
      </Row>

      <hr/>

      <Row>
        <Col>
          <AdditionalInformationField
            value={additionalInformation}
            onChange={onAdditionalInformationChange}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>

      {isIneligible && (
      <PledgeLimitReachedModal
        fundType={FUND_TYPES.WINTERHELP}
        show={showModal}
        handleClose={handleModalClose}
        pledgesApplied={winterHelpPledges}
      />
      )}
    </>
  );
};

export default WinterHelpSection;